import { useState } from 'react';
import Button from '../base/Button';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/84f75d7c-5aa3-41e4-b7ad-dd29b3b984c6/838cdbab-d32d-4b26-b12c-15bffc18506a_poktapok_v1_sin-fondo.png';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: 'Encuentra la Cancha Perfecta',
      subtitle: 'Reserva las mejores canchas de fútbol en tu ciudad',
      image: 'https://readdy.ai/api/search-image?query=modern%20soccer%20field%20with%20green%20grass%2C%20professional%20football%20stadium%2C%20bright%20lighting%2C%20clean%20white%20goal%20posts%2C%20vibrant%20green%20and%20red%20accents%2C%20sports%20facility%20with%20modern%20architecture&width=1200&height=600&seq=hero1&orientation=landscape',
      logoPosition: 'top-8 right-8 md:top-10 md:right-12'
    },
    {
      title: 'Canchas de Primera Calidad',
      subtitle: 'Césped natural y sintético de la mejor calidad',
      image: 'https://readdy.ai/api/search-image?query=high%20quality%20soccer%20field%20with%20artificial%20turf%2C%20professional%20football%20pitch%2C%20stadium%20lights%2C%20green%20grass%20texture%2C%20modern%20sports%20complex%20with%20red%20and%20white%20elements&width=1200&height=600&seq=hero2&orientation=landscape',
      logoPosition: 'bottom-8 left-8 md:bottom-12 md:left-12'
    },
    {
      title: 'Reserva Fácil y Rápida',
      subtitle: 'Sistema de reservas online las 24 horas',
      image: 'https://readdy.ai/api/search-image?query=soccer%20field%20at%20sunset%2C%20beautiful%20football%20stadium%20with%20golden%20lighting%2C%20green%20grass%20field%2C%20modern%20sports%20facility%20with%20red%20and%20white%20architectural%20details&width=1200&height=600&seq=hero3&orientation=landscape',
      logoPosition: 'top-8 left-8 md:top-10 md:left-12'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="relative h-[500px] md:h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-500 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="w-full h-full bg-cover bg-center relative"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-black/40"></div>

            {/* Logo - posición random por slide, más grande */}
            <div className={`absolute ${slide.logoPosition} z-20`}>
              <img
                src={LOGO_URL}
                alt="PokTaPok"
                className="h-28 md:h-36 w-auto object-contain drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]"
              />
            </div>

            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white max-w-4xl px-4">
                <h1 className="text-4xl md:text-6xl font-bold mb-4">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl mb-8 opacity-90">
                  {slide.subtitle}
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button size="lg" className="bg-green-600 hover:bg-green-700">
                    Buscar Canchas
                  </Button>
                  <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-green-600">
                    Publicar Anuncio
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all cursor-pointer z-20"
      >
        <i className="ri-arrow-left-line text-2xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all cursor-pointer z-20"
      >
        <i className="ri-arrow-right-line text-2xl"></i>
      </button>
      
      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
}